import axios from 'axios';

const Axios = axios.create({
    // Your axios configuration here
});

Axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 429) {
            const redirectedAt = sessionStorage.getItem('tooManyRequestsRedirectedAt');
            const now = new Date().getTime();
            const lastUrl = window.location.pathname;

            // Prevent redirect loop if already on "/too-many-requests"
            if (lastUrl !== '/too-many-requests') {
                sessionStorage.setItem('lastVisitedUrl', lastUrl);
            }

            if (!redirectedAt || now - redirectedAt > 45000) {
                sessionStorage.setItem('tooManyRequestsRedirectedAt', now.toString());
                window.location.href = '/too-many-requests';
            }
        }
        return Promise.reject(error);
    }
);

export default Axios;
